import { AssetSchema } from '@dtx-company/connect-codegen/src/gen/asset/v1/asset_pb'
import { Client, createClient } from '@connectrpc/connect'
import { CodeSchema } from '@dtx-company/connect-codegen/src/gen/codes/v2/code_pb'
import { ContainerService } from '@dtx-company/connect-codegen/src/gen/container/v1/container_pb'
import { PageSchema as V1Page } from '@dtx-company/connect-codegen/src/gen/pages/v1/page_pb'
import { PageSchema as V2Page } from '@dtx-company/connect-codegen/src/gen/pages/v2/page_pb'
import { createConnectTransport } from '@connectrpc/connect-web'
import { createRegistry } from '@bufbuild/protobuf'
import { getBaseUrl } from '../utils/url'

export const assetTypeRegistry = createRegistry(CodeSchema, V1Page, V2Page, AssetSchema)

export const getContainerClientBaseUrl = (): string => getBaseUrl('assets/', process.env.APP_ENV)

const containerClient: Client<typeof ContainerService> = createClient(
  ContainerService,
  createConnectTransport({
    baseUrl: getContainerClientBaseUrl(),
    jsonOptions: {
      ignoreUnknownFields: true,
      registry: assetTypeRegistry
    }
  })
)

export default containerClient
